<template>
  <v-container fill-height style="max-width:100%;padding:0;">
    <v-row style="height:100%;">
      <v-col cols="12" xs="12" style="height:100%;padding:0;">
        <v-card :elevation="5" class="card-style">
          <div class="card-style-title" style="color:#00486b;border-top: solid 5px #67c6f3;">
            Cycling to work - top 5 local authorities
            <div class="btnCont">
              <iframe-modal :id="id" :src="src" :width="1700" :height="750" />
              <v-btn
                depressed
                rounded
                color="#00486b"
                style="color:#fff"
                width="7em"
                :href="mapDatasetUrls"
                target="_blank"
              >
                Data
              </v-btn>
            </div>
          </div>
          <v-container v-if="overlay">
            <v-overlay :absolute="true" :value="overlay">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
          </v-container>
          <v-container v-if="!overlay" style="margin:10px;max-width:100%;">
            <v-row style="margin:10px 0;">
              <v-col cols="12" xs="12" sm="12" md="6">
                <div class="description">
                  <p>
                    The top 5 local authorities where residents usually cycle to work, or where
                    cycling is their regular alternative [2017/18]
                  </p>
                  <p class="subtext">
                    This is compared to the national figure of 4.9%
                  </p>
                  <p class="source">
                    <span>
                      Data Source Scottish Household Survey and additional information from
                      Transport Scotland
                    </span>
                  </p>
                </div>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" style="text-align:center">
                <p style="font-weight: bold;">
                  <span style="color:red">1st</span>
                  {{ topResult }}
                </p>
                <div class="donutContainer">
                  <DonutGauge
                    :colors="['#67c6f3', '#4366b7']"
                    logo="zmdi zmdi-desktop-windows"
                    :value="value"
                  />
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <HorizontalBarChart
                  id="top5UsualCycling"
                  :colors="['#67c6f3', '#4366b7']"
                  :data="results"
                  :y-axis="yAxis"
                  :x-axis="xAxis"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import DonutGauge from '@/components/donutGauge.vue';
import HorizontalBarChart from '@/components/horizontalBarChart.vue';
import iframeModal from '@/components/iframeModal.vue';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '../assets/css/material-design-iconic-font.min.css';

export default {
  components: {
    DonutGauge,
    HorizontalBarChart,
    iframeModal,
  },
  data() {
    return {
      results: [],
      overlay: true,
      xAxis: { label: 'Value' },
      yAxis: { label: 'Authority' },
      value: 0,
      topResult: '',
      id: 'top5usualcycling',
      src: 'top5usualcycling',
    };
  },
  computed: {
    ...mapGetters(['compositeDataset']),
    mapDatasetUrls() {
      let d = null;
      if (this.compositeDataset && this.compositeDataset.top5UsuallyCyclingDataset) {
        d = this.compositeDataset.top5UsuallyCyclingDataset.dataset;
        this.content(this.compositeDataset.top5UsuallyCyclingDataset.apiResource);
      } else {
        console.error('No API Resource: ( top5UsuallyCyclingDataset )');
      }
      return d;
    },
  },
  methods: {
    async content(resource) {
      const params = { datasetGUID: resource };
      const newResults = await this.$store.dispatch('fetchData', params);
      this.results = newResults.data;
      let highest = null;
      this.results.forEach((result, index) => {
        const val = parseFloat(result.Value);
        if (highest === null || val > highest.value) {
          highest = { value: val, index, authority: result.Authority };
        }
      });
      this.results.splice(highest.index, 1);
      this.value = highest.value;
      this.topResult = highest.authority;
      this.overlay = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.card-style {
  padding: 2em;
  width: 100%;
  height: 100%;
  justify-content: center;
}
.description {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  p {
    font-size: 1em;
    font-weight: bold;
  }
  .subtext {
    font-size: 0.8em;
  }
  .source {
    font-size: 0.8em;
    font-style: italic;
    font-weight: bold;
  }
}
.donutContainer {
  width: 10em;
  margin: auto;
}
@media (min-width: 650px) {
  .description {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    p {
      font-size: 1.2em;
      font-weight: bold;
    }
    .subtext {
      font-size: 1em;
    }
  }
}
</style>
